/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';
import { CardWrapper, BoxText, BoxButton } from './styles';

// Modal de Ajuda
const HelpModal = ({ onClose, services }) => {
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onClose();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [wrapperRef]);

  return (
    <CardWrapper ref={wrapperRef} services={services} height={(window.innerHeight - 88) - 36}>
      <IconButton
        color="secondary"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
      {services ? (
        <>
          <Title secondary>
            Sobre o Kit e os serviços LOIT
          </Title>
          <BoxText maxHeight={(window.innerHeight - 88) - 107}>
            <Text>
              Oferecemos inicialmente o cálculo dos valores para você poder saber o valor da sua revisão.
            </Text>
            <Text>
              Conhecendo o valor, você pode decidir por buscar a correção do seu saldo num pedido ao Juizado Especial Federal (JEF) de sua região.
            </Text>
            <Text>
              Para isso, nós oferecemos um
              <bold>
                {' '}
                {' '}
                Kit com uma Petição inicial e uma Planilha com o detalhamento dos cálculos,
              </bold>
              {' '}
              que serão necessários para você entrar com o processo no JEF.
            </Text>
            <Text>
              A petição inicial contém seu nome, documentos, endereço e ainda demonstra seu direito, com fundamentos jurídicos simples e diretos. A planilha de cálculo permite que você apresente para o Juiz uma estimativa do quanto seu FGTS perdeu valor de compra com o passar dos anos.
            </Text>
            <Text>
              Além disso, fornecemos também todo o passo-a-passo para que você possa seguir sem a necessidade de contratação de um advogado, desde que o valor da sua correção seja menor do que 60 salários mínimos.
            </Text>
            <Text>
              O valor do Kit + conteúdos de apoio é de apenas R$129,00.
            </Text>
            <Text>
              Para realizar o pagamento utilize um cartão de crédito.
            </Text>
            <a onClick={() => window.open('https://ajuda.tikal.tech/pt-BR/collections/2748191-loit-fgts')}>
              <Text>
                Clique aqui caso tenha mais dúvidas sobre o kit
              </Text>
            </a>
          </BoxText>
        </>
      ) : (
        <>
          <Title secondary>
            Sobre o resultado
          </Title>
          <Text>
            Os valores apresentados após o cálculo dos extratos são corrigidos pelo índice de correção monetária IPCA. Este índice consegue atualizar seu dinheiro do FGTS com base na inflação.
          </Text>
          <Text>
            Estes valores são uma expectativa do que você pode receber. Isso dependerá do julgamento da matéria no Supremo Tribunal Federal.
          </Text>
          <BoxButton>
            <Button onClick={() => {
              window.Intercom('trackEvent', `LOIT FGTS chat de ajuda - ${window.location.pathname.replace(/[0-9]/g, '').replaceAll('/', '')}`);
              window.Intercom('show');
              onClose(false);
            }}
            >
              Iniciar conversa com o suporte
            </Button>
          </BoxButton>
        </>
      )}
    </CardWrapper>
  );
};

HelpModal.defaultProps = {
  services: false,
};

HelpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  services: PropTypes.bool,
};

export default HelpModal;
